// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axiosInstance from "../../utils/axios";

// // ============================================
// // THUNKS
// // ============================================

// // GET /api/my-orders
// export const fetchMyOrders = createAsyncThunk(
//   "myOrders/fetchMyOrders",
//   async (_, { rejectWithValue }) => {
//     try {
//       const { data } = await axiosInstance.get("/api/my/orders");
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // GET /api/my-orders/:id
// export const fetchMyOrderById = createAsyncThunk(
//   "myOrders/fetchMyOrderById",
//   async (orderId, { rejectWithValue }) => {
//     try {
//       const { data } = await axiosInstance.get(`/api/my/orders/${orderId}`);
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // PUT /api/my-orders/:id
// export const updateMyOrder = createAsyncThunk(
//   "myOrders/updateMyOrder",
//   async ({ orderId, payload }, { rejectWithValue }) => {
//     try {
//       const { data } = await axiosInstance.put(
//         `/api/my/orders/${orderId}`,
//         payload
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // DELETE /api/my-orders/:id
// // export const cancelMyOrder = createAsyncThunk(
// //   "myOrders/cancelMyOrder",
// //   async ({ orderId, reason = "" }, { rejectWithValue }) => {
// //     try {
// //       const { data } = await axiosInstance.delete(
// //         `/api/my/orders/${orderId}`,
// //         {
// //           data: { reason },
// //         }
// //       );
// //       return data;
// //     } catch (error) {
// //       return rejectWithValue(error.response?.data || error.message);
// //     }
// //   }
// // );

// // DELETE /api/my/orders/:id
// export const cancelMyOrder = createAsyncThunk(
//   "myOrders/cancelMyOrder",
//   async ({ orderId, reason = "" }, { rejectWithValue }) => {
//     try {
//       const anonId = localStorage.getItem("digital_manu_anonymous_id") || "";
//       const { data } = await axiosInstance.delete(
//         `/api/my/orders/${orderId}`,
//         {
//           headers: {
//             "x-anon-id": anonId,
//           },
//           data: { 
//             reason,
//             anonymousId: anonId 
//           },
//         }
//       );
//       return data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message);
//     }
//   }
// );

// // ============================================
// // INITIAL STATE
// // ============================================
// const initialState = {
//   orders: [],
//   currentOrder: null,
//   loading: false,
//   error: null,
//   success: false,
//   totalOrders: 0,
//   totalPages: 1,
//   currentPage: 1,
// };

// // ============================================
// // SLICE
// // ============================================
// const myOrdersSlice = createSlice({
//   name: "myOrders",
//   initialState,
//   reducers: {
//     clearMyOrdersError: (s) => {
//       s.error = null;
//     },
//     clearMyOrdersSuccess: (s) => {
//       s.success = false;
//     },
//     clearCurrentMyOrder: (s) => {
//       s.currentOrder = null;
//     },
//     resetMyOrdersState: () => initialState,

//     // 🔥 Socket se real-time update
//     socketOrderUpsert: (s, a) => {
//       const updated = a.payload?.order || a.payload;
//       if (!updated?._id) return;

//       const idx = s.orders.findIndex((o) => o._id === updated._id);
//       if (idx !== -1) {
//         s.orders[idx] = updated;
//       } else {
//         s.orders.unshift(updated);
//       }

//       if (s.currentOrder?._id === updated._id) {
//         s.currentOrder = updated;
//       }
//     },

//     // 🔥 Socket se cancel
//     socketOrderCancelled: (s, a) => {
//       const orderId = a.payload?.orderId || a.payload?.order?._id;
//       if (!orderId) return;

//       const idx = s.orders.findIndex((o) => o._id === orderId);
//       if (idx !== -1) {
//         s.orders[idx] = {
//           ...s.orders[idx],
//           ...(a.payload?.order || {}),
//           status: "CANCELLED",
//         };
//       }
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // FETCH ALL
//       .addCase(fetchMyOrders.pending, (s) => {
//         s.loading = true;
//         s.error = null;
//       })
//       .addCase(fetchMyOrders.fulfilled, (s, a) => {
//         s.loading = false;
//         s.orders = a.payload.orders || [];
//         s.totalOrders = a.payload.totalOrders || 0;
//         s.totalPages = a.payload.totalPages || 1;
//         s.currentPage = a.payload.currentPage || 1;
//       })
//       .addCase(fetchMyOrders.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload?.message || "Failed to fetch orders";
//       })

//       // FETCH ONE
//       .addCase(fetchMyOrderById.pending, (s) => {
//         s.loading = true;
//         s.error = null;
//       })
//       .addCase(fetchMyOrderById.fulfilled, (s, a) => {
//         s.loading = false;
//         s.currentOrder = a.payload.order;
//       })
//       .addCase(fetchMyOrderById.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload?.message || "Failed to fetch order";
//       })

//       // UPDATE
//       .addCase(updateMyOrder.pending, (s) => {
//         s.loading = true;
//         s.error = null;
//         s.success = false;
//       })
//       .addCase(updateMyOrder.fulfilled, (s, a) => {
//         s.loading = false;
//         s.success = true;
//         const updated = a.payload.order;
//         const idx = s.orders.findIndex((o) => o._id === updated._id);
//         if (idx !== -1) s.orders[idx] = updated;
//         s.currentOrder = updated;
//       })
//       .addCase(updateMyOrder.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload?.message || "Failed to update order";
//       })

//       // CANCEL
//       .addCase(cancelMyOrder.pending, (s) => {
//         s.loading = true;
//         s.error = null;
//         s.success = false;
//       })
//       .addCase(cancelMyOrder.fulfilled, (s, a) => {
//         s.loading = false;
//         s.success = true;
//         const updated = a.payload.order;
//         const idx = s.orders.findIndex((o) => o._id === updated._id);
//         if (idx !== -1) s.orders[idx] = updated;
//         if (s.currentOrder?._id === updated._id) s.currentOrder = updated;
//       })
//       .addCase(cancelMyOrder.rejected, (s, a) => {
//         s.loading = false;
//         s.error = a.payload?.message || "Failed to cancel order";
//       });
//   },
// });

// export const {
//   clearMyOrdersError,
//   clearMyOrdersSuccess,
//   clearCurrentMyOrder,
//   resetMyOrdersState,
//   socketOrderUpsert,
//   socketOrderCancelled,
// } = myOrdersSlice.actions;

// export default myOrdersSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";

// ============================================
// THUNKS
// ============================================

// GET /api/my/orders  (paginated)
export const fetchMyOrders = createAsyncThunk(
  "myOrders/fetchMyOrders",
  async (args = {}, { rejectWithValue }) => {
    const { page = 1, limit = 8, append = false } = args || {};
    try {
      const anonId =
        localStorage.getItem("digital_manu_anonymous_id") || "";
      const { data } = await axiosInstance.get("/api/my/orders", {
        params: { page, limit },
        headers: anonId ? { "x-anon-id": anonId } : undefined,
      });
      return { ...data, append, requestedPage: page };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// GET /api/my/orders/:id
export const fetchMyOrderById = createAsyncThunk(
  "myOrders/fetchMyOrderById",
  async (orderId, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.get(`/api/my/orders/${orderId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// PUT /api/my/orders/:id
export const updateMyOrder = createAsyncThunk(
  "myOrders/updateMyOrder",
  async ({ orderId, payload }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance.put(
        `/api/my/orders/${orderId}`,
        payload
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// DELETE /api/my/orders/:id
export const cancelMyOrder = createAsyncThunk(
  "myOrders/cancelMyOrder",
  async ({ orderId, reason = "" }, { rejectWithValue }) => {
    try {
      const anonId = localStorage.getItem("digital_manu_anonymous_id") || "";
      const { data } = await axiosInstance.delete(
        `/api/my/orders/${orderId}`,
        {
          headers: { "x-anon-id": anonId },
          data: { reason, anonymousId: anonId },
        }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// ============================================
// INITIAL STATE
// ============================================
const initialState = {
  orders: [],
  currentOrder: null,
  loading: false,
  loadingMore: false, // ⭐ pagination spinner
  error: null,
  success: false,
  totalOrders: 0,
  totalPages: 1,
  currentPage: 1,
  hasMore: true, // ⭐ end-of-list flag
};

const PAGE_SIZE = 8;

// ============================================
// SLICE
// ============================================
const myOrdersSlice = createSlice({
  name: "myOrders",
  initialState,
  reducers: {
    clearMyOrdersError: (s) => {
      s.error = null;
    },
    clearMyOrdersSuccess: (s) => {
      s.success = false;
    },
    clearCurrentMyOrder: (s) => {
      s.currentOrder = null;
    },
    resetMyOrdersState: () => initialState,

    socketOrderUpsert: (s, a) => {
      const updated = a.payload?.order || a.payload;
      if (!updated?._id) return;
      const idx = s.orders.findIndex((o) => o._id === updated._id);
      if (idx !== -1) s.orders[idx] = updated;
      else s.orders.unshift(updated);
      if (s.currentOrder?._id === updated._id) s.currentOrder = updated;
    },

    socketOrderCancelled: (s, a) => {
      const orderId = a.payload?.orderId || a.payload?.order?._id;
      if (!orderId) return;
      const idx = s.orders.findIndex((o) => o._id === orderId);
      if (idx !== -1) {
        s.orders[idx] = {
          ...s.orders[idx],
          ...(a.payload?.order || {}),
          status: "CANCELLED",
        };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH ALL (paginated)
      .addCase(fetchMyOrders.pending, (s, a) => {
        const append = a.meta.arg?.append;
        if (append) s.loadingMore = true;
        else s.loading = true;
        s.error = null;
      })
      .addCase(fetchMyOrders.fulfilled, (s, a) => {
        s.loading = false;
        s.loadingMore = false;

        const {
          orders = [],
          totalOrders = 0,
          totalPages = 1,
          currentPage = 1,
          append,
        } = a.payload || {};

        if (append) {
          // Merge + dedupe by _id
          const seen = new Set(
            s.orders.map((o) => String(o._id || o.id))
          );
          orders.forEach((o) => {
            const id = String(o._id || o.id);
            if (!seen.has(id)) {
              s.orders.push(o);
              seen.add(id);
            }
          });
        } else {
          s.orders = orders;
        }

        s.totalOrders = totalOrders || s.orders.length;
        s.totalPages = totalPages || 1;
        s.currentPage = currentPage || 1;
        s.hasMore = (currentPage || 1) < (totalPages || 1);
      })
      .addCase(fetchMyOrders.rejected, (s, a) => {
        s.loading = false;
        s.loadingMore = false;
        s.error = a.payload?.message || "Failed to fetch orders";
      })

      // FETCH ONE
      .addCase(fetchMyOrderById.pending, (s) => {
        s.loading = true;
        s.error = null;
      })
      .addCase(fetchMyOrderById.fulfilled, (s, a) => {
        s.loading = false;
        s.currentOrder = a.payload.order;
      })
      .addCase(fetchMyOrderById.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload?.message || "Failed to fetch order";
      })

      // UPDATE
      .addCase(updateMyOrder.pending, (s) => {
        s.loading = true;
        s.error = null;
        s.success = false;
      })
      .addCase(updateMyOrder.fulfilled, (s, a) => {
        s.loading = false;
        s.success = true;
        const updated = a.payload.order;
        const idx = s.orders.findIndex((o) => o._id === updated._id);
        if (idx !== -1) s.orders[idx] = updated;
        s.currentOrder = updated;
      })
      .addCase(updateMyOrder.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload?.message || "Failed to update order";
      })

      // CANCEL
      .addCase(cancelMyOrder.pending, (s) => {
        s.loading = true;
        s.error = null;
        s.success = false;
      })
      .addCase(cancelMyOrder.fulfilled, (s, a) => {
        s.loading = false;
        s.success = true;
        const updated = a.payload.order;
        const idx = s.orders.findIndex((o) => o._id === updated._id);
        if (idx !== -1) s.orders[idx] = updated;
        if (s.currentOrder?._id === updated._id) s.currentOrder = updated;
      })
      .addCase(cancelMyOrder.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload?.message || "Failed to cancel order";
      });
  },
});

export const {
  clearMyOrdersError,
  clearMyOrdersSuccess,
  clearCurrentMyOrder,
  resetMyOrdersState,
  socketOrderUpsert,
  socketOrderCancelled,
} = myOrdersSlice.actions;

export { PAGE_SIZE };
export default myOrdersSlice.reducer;